import Vue from "vue";
import Vuex from "vuex";
import news from "./news";
import form from "./form";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: { news, form },
});
